export const SELECT_TAB = "SELECT_TAB";
export type TabState = string;

export interface changeTabAction {
  type: typeof SELECT_TAB;
  payload: TabState;
}

export type TabActionTypes = changeTabAction;
